import { createContext, useContext } from 'react';

export const VendorPageEditContext = createContext();

export default VendorPageEditContext;

export const useVendorPageEditContext = () => useContext(VendorPageEditContext);
